import React from 'react';
import { BrandOptionFields } from '../../../models/course/ICourseContent';
import styles from './course-modules-us.module.scss';
import { IModule } from '../../../models/course/ICourseData';

export type Props = {
  modules: IModule[];
  semester?: string;
  brandOptions: BrandOptionFields;
};
export default function CourseModulesUS({ modules, semester, brandOptions }: Props) {
  return (
    <div className={styles.modules}>
      {semester !== 'undefined' && <h4 className='mb-3'>{brandOptions?.termName} {semester}</h4>}
      <div className={styles['modules-rows']}>
        {modules.map((module, index) => (
          <CourseModuleRow
            module={module}
            brandOptions={brandOptions}
            key={index + module.code + module.semesterTermTaught}
          />
        ))}
      </div>
      <div className={`row ${styles.row}`}>
        <div className='col-md-3'></div>
        <div className='col-md-6'>
          Total{' '}
          {brandOptions?.customizeCredits ? brandOptions.customizeCredits.toLowerCase() : 'credits'}
        </div>
        <div id={`total-credits`} className={`col-md-3 ${styles['credit-value']}`}>
          {modules.map((el) => (el.credits ? +el.credits : 0)).reduce((acc, curr) => acc + curr, 0)}
          {` ${brandOptions?.customizeCredits || 'Credits'}`}
        </div>
      </div>
    </div>
  );
}
const CourseModuleRow: React.FC<{ module: IModule; brandOptions: BrandOptionFields }> = ({
  module,
  brandOptions,
}) => {
  return (
    <div className={`row mb-3 ${styles.row}`}>
      <div className='col-md-3'>{module.code}</div>
      <div className='col-md-6'>
        <span className={module.deliveredBy === 'INTO' ? styles.into : undefined}>
          {module.name}
        </span>
      </div>
      <div className={`col-md-3 ${styles['credit-value']}`}>
        {module.credits} {brandOptions?.customizeCredits || 'Credits'}
      </div>
    </div>
  );
};
